import { Directive, ElementRef, AfterViewInit } from '@angular/core';

/**
 * This directive will cause the element to which it's attached to gain focus when created.
 */
@Directive({
	selector: '[ccAutoFocus]'
})
export class AutoFocusDirective implements AfterViewInit {

// #region [ Fields ]

	/** The DOM element this directive is tied to. */
	private _Element: ElementRef;

// #region [ Constructor ]

	constructor(Element: ElementRef) {
		this._Element = Element;
	}

// #region [ Implemented Methods ]

	/**
	 * After view initilized event.
	 */
	public ngAfterViewInit(): void {
		let objElement: HTMLElement;

		objElement = this._Element.nativeElement;
		objElement.focus();
	}
	
}